import { render } from "./Classifier.vue?vue&type=template&id=dfd9f152"
import script from "./Classifier.vue?vue&type=script&lang=js"
export * from "./Classifier.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mark/Documents/vs_workspaces/sadc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__